import useReduxState from '@portal/hooks/useReduxState';
import { translate } from '@portal/services/i18n';
import { Radio } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';

export interface LoanInstallmentsProps {
  amount: number;
  dueDate: DateTime;
  selectedInstallment: number | null;
  setSelectedInstallment: (value: number) => void;
}

const LoanInstallments = ({
  selectedInstallment,
  setSelectedInstallment,
}: LoanInstallmentsProps) => {
  const { simulations } = useReduxState().loan;

  return (
    <div className="loan-installments">
      <p className="loan-installments__title">
        {translate('PAGES.LOAN.SIMULATE.INSTALLMENTS.INSTALLMENTS')}
      </p>

      <Radio.Group
        className="loan-installments__radio-container"
        value={selectedInstallment}
      >
        {simulations?.installments.map((simulation) => (
          <Radio
            className="loan-installments__radio-container__radio"
            key={simulation.installments}
            value={simulation.installments}
            onChange={() => setSelectedInstallment(simulation.installments)}
          >
            <div className="loan-installments__radio-container__radio__container">
              <p className="loan-installments__radio-container__radio__container__installment">
                {simulation.installments}x
              </p>
            </div>
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
};

export default LoanInstallments;
